// src/data/apartments.js
export const apartmentsData = [
  {
    id: 1,
    name: 'Apartament Słoneczny',
    subtitle: 'Luksusowy apartament',
    description:
      'Elegancki apartament Słoneczny oferuje najwyższy standard komfortu. Znajduje się w okolicy bocznego wejścia do Parku Czartoryskich w Puławach. To idealna propozycja dla osób, które cenią sobie domową atmosferę,komfort i ciszę. Szybki internet umożliwia pracę zdalną w czasie pobytu.',
    longDescription: `
      Przestronny salon z telewizorem Smart TV zapewnia doskonałe miejsce do relaksu. Pełne wyposażenie kuchni z niezbednymi urządzeniami pozwala na przygotowanie posiłków, a także na poranną kawę czy wieczorny drink. 
      
      Główna sypialnia wyposażona jest w komfortowe łóżko 140x200 ( możliwość dostawienia łóżeczka dla dziecka) plus sofa, a w drugim pokoju znajdują się 2 pojedyńcze łóżka oraz stół do pracy. Łazienka z prysznicem pozwala na relaks po całym dniu. Apartament znajduje się w doskonałej lokalizacji z łatwym dostępem do komunikacji publicznej, restauracji i głównych atrakcji miasta.
       Idealne rozwiązanie dla osób podróżujących w interesach, par szukających komfortowego pobytu oraz rodzin z dziećmi.
    
    `,
    specs: {
      area: '47,4 m²',
      rooms: '2 pokoje + kuchnia',
      guests: '2+4 osoby',
      floor: 'wysoki parter',
    },
    images: [
      '/images/deluxe/01.jpg',
      '/images/deluxe/02.jpg',
      '/images/deluxe/03.jpg',
      '/images/deluxe/04.jpg',
      '/images/deluxe/05.jpg',
      '/images/deluxe/06.jpg',
      '/images/deluxe/07.jpg',
      '/images/deluxe/08.jpg',
      '/images/deluxe/09.jpg',
      '/images/deluxe/10.jpg',
      '/images/deluxe/11.jpg',
      '/images/deluxe/12.jpg',
    ],
    amenities: {
      general: [
        'Prywatna łazienka',
        'Bezpłatny parking',
        'Prywatny parking',
        'Pokoje dla niepalących',
      ],
      room: [
        'Pościel',
        'Szafa lub garderoba',
        'Sofa',
        'Biurko',
        'Gniazdko koło łóżka',
        'Rozkładana sofa',
        'Suszarka na ubrania',
        'Wieszak na ubrania',
        'Drewniana podłoga lub parkiet',
        'Sprzęt do prasowania',
        'Żelazko',
      ],
      bathroom: [
        'Papier toaletowy',
        'Ręczniki',
        'Wanna lub prysznic',
        'Prywatna łazienka',
        'Prysznic',
      ],
      kitchen: [
        'Ekspres do kawy',
        'Środki czystości',
        'Piekarnik',
        'Przybory kuchenne',
        'Kuchnia',
        'Pralka',
        'Kuchenka mikrofalowa',
        'Lodówka',
      ],
      media: [
        'Telewizor z płaskim ekranem',
        'Kanały kablowe',
        'Radio',
        'Telewizor',
        'Bezpłatne Wi-Fi',
      ],
    },
    features: [
      '47,4m² powierzchni',
      '2 pokoje + kuchnia',
      'Miejsce parkingowe na ogrodzonym terenie',
      'Ogrodzony teren przed blokiem z placem dla dzieci',
      'Zabawki, gry i książki dostępne dla gości'
    ],
  },
  {
    id: 2,
    name: 'Apartament Kameralny',
    subtitle: 'Komfortowy apartament w doskonałej lokalizacji',
    description:
      'To idealna propozycja dla osób, które cenią sobie domową atmosferę,komfort i ciszę. Możliwość pełnego relaksu po intensywnym dniu. Lokalizacja  blisko Parku Czartoryskich w Puławach. Szybki internet umożliwia pracę zdalną w czasie pobytu.',
    longDescription: `
      Apartament Kameralny łączy w sobie funkcjonalność z estetyką. Maksymalnie wykorzystuje dostępną przestrzeń. Standardowe wyposażenie pozwala poczuć się jak w domu. W pełni wyposażona kuchnia plus niezbędny sprzęt umożliwiają przygotowanie posiłków. Łóżko King-Size (160x200) pozwala na spokojny sen nawet z małym dzieckiem ( możliwość dostawienia łóżeczka dla dziecka) plus sofa rozkładana zapewnia komfortowy sen, a stół roboczy oraz szybki internet umożliwiają pracę zdalną w czasie pobytu. Łazienka z prysznicem pozwala na relaks po całym dniu.
      
      Apartament znajduje się w doskonałej lokalizacji z łatwym dostępem do komunikacji publicznej, restauracji i głównych atrakcji miasta. Idealne rozwiązanie dla osób podróżujących w interesach, par szukających komfortowego pobytu oraz rodzin z dziećmi.
    `,
    specs: {
      area: '36,1 m²',
      rooms: '1 pokój + kuchnia',
      guests: '2+2 osoby',
      floor: '2. piętro bez windy',
      
    },
    images: [
      '/images/standard/01.jpg',
      '/images/standard/02.jpg',
      '/images/standard/03.jpg',
      '/images/standard/04.jpg',
      '/images/standard/05.jpg',
      '/images/standard/06.jpg',
      '/images/standard/07.jpg',
      '/images/standard/08.jpg',
      '/images/standard/09.jpg',
      '/images/standard/10.jpg',
      '/images/standard/11.jpg',
      '/images/standard/12.jpg',
    ],
    amenities: {
      pobyt: [
        'Prywatna łazienka',
        'Bezpłatny parking',
        'Parking',
        'Kuchnia',
        'Bezpłatne Wi-Fi',
        'Pralka',
        'Telewizor z płaskim ekranem',
        'Pokoje dla niepalących',
        'Prysznic',
        'Ekspres do kawy',
      ],
      parking: [
        'Bezpłatny parking publiczny jest dostępny na miejscu (konieczna jest rezerwacja)',
      ],
      internet: [
        'Szybkie bezpłatne Wi-Fi 533 Mb/s. Odpowiednie do streamingu treści w jakości 4K i prowadzenia wideorozmów na wielu urządzeniach. Test prędkości wykonany przez gospodarza',
      ],
      kuchnia: [
        'Stół',
        'Ekspres do kawy',
        'Środki czystości',
        'Płyta kuchenna',
        'Piekarnik',
        'Przybory kuchenne',
        'Kuchnia',
        'Pralka',
        'Zmywarka',
        'Kuchenka mikrofalowa',
        'Lodówka',
      ],
      sypialnia: [
        'Pościel',
        'Szafa lub garderoba',
      ],
      lazienka: [
        'Papier toaletowy',
        'Ręczniki',
        'Wanna lub prysznic',
        'Prywatna łazienka',
        'Suszarka do włosów',
        'Prysznic',
      ],
      salon: [
        'Sofa',
      ],
      media: [
        'Telewizor z płaskim ekranem',
        'Kanały kablowe',
        'Telewizor',
      ],
      udogodnienia: [
        'Gniazdko koło łóżka',
        'Rozkładana sofa',
        'Suszarka na ubrania',
        'Wieszak na ubrania',
        'Drewniana podłoga lub parkiet',
        'Sprzęt do prasowania',
        'Żelazko',
      ],
    },
    features: [
      '36m² powierzchni',
      '1 pokój + kuchnia',
      'Widok na kameralne osiedle ',
      'Smart TV i WiFi',
      'Biblioteczka z książkami  ',
      'Miejsce parkingowe na ogrodzonym terenie',

    ],
  },
];

export const contactInfo = {
  phone: '+48 600 761 250',
  email: 'office@ibtm.pl',
  hours: 'Poniedziałek - Niedziela, 8:00 - 22:00',
  location: 'Centrum miasta, Polska',
  companyName: 'BTM Sp. z o.o.',
  nip: '9462531550',
  regon: '061092285',
  address: 'ul. Księżnej Izabelli 8/1 24-100 Puławy',
};

export const benefits = [
  {
    title: 'Komfort jak w domu',
    description:
      'Pełne wyposażenie kuchni, łazienki i wszystko co potrzebne do komfortowego pobytu.',
  },
  {
    title: 'Świetna lokalizacja',
    description:
      'Apartamenty w centrum miasta z doskonałym dostępem do komunikacji publicznej.',
  },
  {
    title: 'Wysoka jakość',
    description:
      'Nowoczesne apartamenty utrzymane w najwyższym standardzie.',
  },
  {
    title: 'Konkurencyjne ceny',
    description:
      'Atrakcyjne ceny z możliwością negocjacji dla dłuższych pobytów.',
  },
];

export const amenityCategories = {
  general: 'Ogólne',
  room: 'Pokój',
  bathroom: 'Łazienka',
  kitchen: 'Kuchnia',
  media: 'Media/Technologia',
  pobyt: 'Świetne na Twój pobyt',
  parking: 'Parking',
  internet: 'Internet',
  kuchnia: 'Kuchnia',
  sypialnia: 'Sypialnia',
  lazienka: 'Łazienka',
  salon: 'Salon',
  udogodnienia: 'Udogodnienia w pokoju',
};